import React from "react";
import styled from "styled-components";
import SettingsList from "./SettingsList";

import Icon from "./Icon";
import w from "./images/settings-white.png";
import b from "./images/settings-black.png";

const Container = styled.div`
    width: 30px;
    height: 30px;
`;

type Props = {
    doc_id: number;
    enableDarkTheme: boolean;
    canAdminister: boolean;
};
type State = {
    show: boolean;
};
export default class SettingsIcon extends React.Component<Props, State> {
    private timeout: ReturnType<typeof setTimeout> | null = null;
    private elmIcon: React.RefObject<Icon>;

    constructor(props: Props) {
        super(props);
        this.state = {
            show: false,
        };

        this.elmIcon = React.createRef<Icon>();
    }

    componentWillUnmount() {
        this.timeout && clearTimeout(this.timeout);
    }

    hide = () => {
        this.timeout = setTimeout(() => {
            this.setState({ show: false });
        }, 200);
    };

    onClick = () => this.setState({ show: !this.state.show });

    view() {
        const { doc_id, enableDarkTheme, canAdminister } = this.props;

        return (
            <SettingsList
                iconElm={this.elmIcon}
                doc_id={doc_id}
                hideMenu={this.hide}
                canAdminister={canAdminister}
                enableDarkTheme={enableDarkTheme}
            />
        );
    }

    render() {
        const { enableDarkTheme } = this.props;

        return (
            <Container>
                {this.state.show && this.view()}
                <Icon
                    ref={this.elmIcon}
                    onClick={this.onClick}
                    w={w}
                    b={b}
                    width={30}
                    height={30}
                    enableDarkTheme={enableDarkTheme}
                />
            </Container>
        );
    }
}
